export default __webpack_public_path__ + "static/media/source_fund.546cbcbb.svg";